import { IconContent } from '@icons';

export const clinical: IconContent = {
    md: '<g fill-rule="evenodd" clip-rule="evenodd"><path d="M4.78 12.37 12 19.58l7.19-7.19.06-.04a4.62 4.62 0 1 0-6.45-6.5L12 6.91l-.8-1.06a4.62 4.62 0 1 0-6.48 6.47l.06.05ZM12 21l-7.88-7.88A5.62 5.62 0 1 1 12 5.25 5.65 5.65 0 0 1 16.5 3a5.63 5.63 0 0 1 3.34 10.15L12 21Z"/><path d="m10.16 9.86-.79 2.64H6v-1h2.63l1.1-3.64.95.02 1.42 5.51 1.24-3.08.85-.12 1.05 1.31H18v1h-3.24l-.81-1.02-1.49 3.7-.94-.06-1.36-5.26Z"/></g>',
};
